import service from "../service";

export const getCommerceTypeService = (rol, hosterOwner) => new Promise((resolve) => resolve([
  ['Administrador', 'H2H'].includes(rol) && { id: 'H2H', name: "H2H" },
  ['Administrador', 'Distribuidor'].includes(rol) && !hosterOwner && { id: 'DISTRIBUIDOR', name: "Distribuidor" },
  ['Administrador', 'Distribuidor', 'Menudeo'].includes(rol) && { id: 'MENUDEO', name: "Menudeo" },
].filter(item => item)))

// Sin tipo se piden todos. La API sólo reconoce 'all' como «cualquier tipo»: sin esto la
// URL salía como v3/comercio/undefined y funcionaba de casualidad.
export const getCommercesService = (type, state, group) => (
  service('post', `v3/comercio/${type || 'all'}`, { data: { state, group } })
)
export const getDeepCommercesService = (type, state, group) => (
  service('post', `v3/comercio/todos`, { data: { state, group } })
)

// Lista PLANA de comercios para el arbol de la red: solo lo que pinta un nodo.
// Se arma la jerarquia en el panel, asi un comercio cuyo padre ya no existe se
// detecta en vez de desaparecer.
export const getCommerceTreeService = () => (
  service('get', `v3/comercio/arbol`)
)

export const createCommerceService = (data) => (
  service('post', `v3/comercio`, { data })
)
export const createMultipleCommerceService = (data) => (
  service('post', `v3/comercio/multiple`, { data })
)

export const updateCommerceService = (idCommerce, data) => (
  service('patch', `v3/comercio/${idCommerce}`, { data })
)
export const updateCommerceStateService = (idCommerce, data) => (
  service('patch', `v3/comercio/${idCommerce}/estado`, { data })
)

export const removeCommerceService = (idCommerce) => (
  service('delete', `v3/comercio/${idCommerce}`)
)
